export default {
	search(params, cb, ecb) {
		this.http
			.get('/voucher/search', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchVoucherUser(params, cb, prof = 'full') {
		this.http
			.get(`/voucher/searchVoucherUser/${prof}`, {
				params
			})
			.then((r) => cb && cb(r))
	},
	getList(params, cb) {
		//deprecated
		this.http
			.get(
				`/voucher/getVoucherList/${params.status}/${params.pageno}/${params.pagesize}`,
				{}
			)
			.then((r) => cb && cb(r))
	},
	getVouchers(params, cb) {
		this.http
			.get(
				`/voucher/getVouchers/${params.status}/${params.pageno}/${params.pagesize}`,
				{}
			)
			.then((r) => cb && cb(r))
	},
	getById(id, cb) {
		this.http.get('/voucher/getById/' + id, {}).then((response) => {
			cb(response)
		})
	},
	getByIds(ids, cb, ecb, config) {
		this.http
			.get(`/voucher/getByIds/${ids}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getVoucherUserById(vuid, cb, ecb) {
		this.http
			.get('/voucher/getVoucherById/' + vuid, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/voucher/update', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	apply(id, cb, config = {}, ecb = null) {
		this.http
			.get(`/voucher/apply/${id}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	markUsed(id, cb, config = {}, ecb = null) {
		this.http
			.get(`/voucher/markUsed/${id}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	send(params, cb, ecb) {
		this.http
			.post('/voucher/send/', params)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	sendAndMark(params, cb, ecb) {
		this.http
			.post('/voucher/sendAndMark/', params)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	withdraw(id, cb, ecb) {
		this.http
			.get('/voucher/withdraw/' + id, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	reclaim(id, cb, ecb) {
		this.http
			.get(`/voucher/reclaim/${id}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	status(id, to, cb, ecb) {
		this.http
			.get(`/voucher/status/${id}/${to}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	extend(params, cb, ecb) {
		this.http
			.post('/voucher/extend/', params)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
